import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

import Layout from "../../../layout";

import validate from "./form-validate";

const MarcoHistoricoCadastrar = () => {
  const location = useLocation();
  const history = useHistory();

  const [state, setState] = useState({
    id: 0,
    ano: "",
    descricao: "",
    titulo: "",
    titulo_es: "",
    titulo_in: "",
    descricao_in: "",
    descricao_es: ""
  });

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-marco-historico").valid()) {
      return;
    }

    try {
      const enviar = state.id > 0 ? api.put : api.post;

      const requisicao = await enviar("/marco-historico", state);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      success(data.mensagem);
      history.push("/marco-historico");
    } catch (error) {
      console.log(error);
      danger("Erro ao cadastrar o marco histórico.");
    }
  };

  useEffect(() => {
    const carregarDados = async () => {
      if (!location.state) {
        return;
      }

      try {
        showLoading(".ibox-content");

        const requisicao = await api.get(
          `/marco-historico/${location.state.id}`
        );

        const { data } = requisicao;

        if (!data.status) {
          danger(data.mensagem);
          return;
        }

        if (!data.data) {
          return;
        }

        setState(data.data);
        showLoading(".ibox-content");
      } catch (error) {
        console.log(error);
        showLoading(".ibox-content");
        danger("Erro ao carregar os dados do marco histórico");
      }
    };

    let validacao = window.$("#form-marco-historico").validate(validate);

    carregarDados();

    return () => validacao.destroy();
  }, [location.state]);

  return (
    <>
      <Layout
        titulo="Ibraflex - Marcos Históricos"
        header="Cadastro do Marco Histórico"
        action={{ titulo: "Voltar", link: "/marco-historico" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>Dados do marco histórico</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                <div className="row">
                  <div className="col-lg-12">
                    <form id="form-marco-historico">
                      
                      <div class="row">
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label>Ano do marco histórico</label>
                            <input
                              type="numeric"
                              placeholder="Ano do marco histórico"
                              className="form-control"
                              name="ano"
                              value={state.ano}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div class="col-lg-12">
                          <div className="form-group">
                            <div class="tabs-container">
                              <ul class="nav nav-tabs" role="tablist">
                                <li>
                                  <a
                                    class="nav-link active nav-tab"
                                    data-toggle="tab"
                                    href="#tab-1"
                                  >
                                    Português
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="nav-link nav-tab"
                                    data-toggle="tab"
                                    href="#tab-2"
                                  >
                                    Inglês
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="nav-link nav-tab"
                                    data-toggle="tab"
                                    href="#tab-3"
                                  >
                                    Espanhol
                                  </a>
                                </li>
                              </ul>
                              <div class="tab-content">
                                <div
                                  role="tabpanel"
                                  id="tab-1"
                                  class="tab-pane active"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Título do marco histórico</label>
                                          <input
                                            type="text"
                                            placeholder="Título do marco histórico"
                                            className="form-control"
                                            name="titulo"
                                            value={state.titulo}
                                            onChange={(e) => preencherValoresEdits(e)}
                                          />
                                        </div>
                                      </div>
                          
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12">
                                          <div className="form-group">
                                            <label>Descrição do marco histórico</label>
                                            <textarea
                                              className="form-control"
                                              id="descricao"
                                              name="descricao"
                                              placeholder="Descrição do marco histórico."
                                              rows="8"
                                              value={state.descricao}
                                              onChange={(e) => preencherValoresEdits(e)}
                                            />
                                          </div>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  role="tabpanel"
                                  id="tab-2"
                                  class="tab-pane"
                                >
                                  <div class="panel-body">
                                  <div className="row">
                                    <div className="col-lg-9">
                                      <div className="form-group">
                                        <label>Título do marco histórico </label>
                                        <input
                                          type="text"
                                          placeholder="Título do marco histórico"
                                          className="form-control"
                                          name="titulo_in"
                                          value={state.titulo_in}
                                          onChange={(e) => preencherValoresEdits(e)}
                                        />
                                      </div>
                                    </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12">
                                          <div className="form-group">
                                            <label>Descrição do marco histórico</label>
                                            <textarea
                                              className="form-control"
                                              id="descricao_in"
                                              name="descricao_in"
                                              placeholder="Descrição do marco histórico."
                                              rows="8"
                                              value={state.descricao_in}
                                              onChange={(e) => preencherValoresEdits(e)}
                                            />
                                          </div>
                                        </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  role="tabpanel"
                                  id="tab-3"
                                  class="tab-pane"
                                >
                                  <div class="panel-body">
                                  <div className="row">
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <label>Título do marco histórico</label>
                                        <input
                                          type="text"
                                          placeholder="Título do marco histórico"
                                          className="form-control"
                                          name="titulo_es"
                                          value={state.titulo_es}
                                          onChange={(e) => preencherValoresEdits(e)}
                                        />
                                      </div>
                                    </div>
                          
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12">
                                          <div className="form-group">
                                            <label>Descrição do marco histórico</label>
                                            <textarea
                                              className="form-control"
                                              id="descricao_es"
                                              name="descricao_es"
                                              placeholder="Descrição do marco histórico."
                                              rows="8"
                                              value={state.descricao_es}
                                              onChange={(e) => preencherValoresEdits(e)}
                                            />
                                          </div>
                                        </div>
                                    </div>
                                      
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      

                      <div>
                        <button
                          className="btn btn-sm btn-success float-right m-t-n-xs"
                          type="submit"
                          onClick={(e) => enviarFormulario(e)}
                        >
                          <strong>Salvar</strong>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default MarcoHistoricoCadastrar;
